import { UnifiedIcons, getUnifiedEmoji } from '../unifiedTools.js';
import './PlusComposerMenu.css';

/**
 * Shared + menu for the homepage composer and the chatbot composer.
 * Keep item order and labels identical so both surfaces stay in sync.
 */
export default function PlusComposerMenu({
  tools = [],
  onUploadFiles,
  onToolClick,
  onClearChat,
}) {
  return (
    <div className="search-dropdown search-glass plus-composer-menu">
      <div className="search-dropdown-content">
        <div className="plus-menu-options">
          <div
            className="plus-menu-item"
            role="button"
            tabIndex={0}
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              onUploadFiles?.();
            }}
            onKeyDown={(e) => {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                onUploadFiles?.();
              }
            }}
          >
            <svg className="plus-menu-glyph" viewBox="0 0 24 24" fill="none" aria-hidden="true">
              <path d="M3.5 7.5V6.2A1.7 1.7 0 0 1 5.2 4.5h4.1l1.6 1.8h7.9a1.7 1.7 0 0 1 1.7 1.7v9.3a1.7 1.7 0 0 1-1.7 1.7H5.2a1.7 1.7 0 0 1-1.7-1.7V7.5Z" stroke="currentColor" strokeWidth="1.6" strokeLinejoin="round" />
              <path d="M12 16.2V10.6M9.6 12.7 12 10.4l2.4 2.3" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
            <span>Upload Files</span>
          </div>

          {tools.map((tool) => {
            const Icon = tool.icon && UnifiedIcons[tool.icon] ? UnifiedIcons[tool.icon] : null;
            const emoji = getUnifiedEmoji(tool.icon);
            return (
              <div
                key={tool.key}
                className="plus-menu-item"
                role="button"
                tabIndex={0}
                onClick={() => onToolClick?.(tool)}
                onKeyDown={(e) => {
                  if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    onToolClick?.(tool);
                  }
                }}
              >
                {Icon ? <Icon /> : null}
                {!Icon && emoji ? `${emoji} ` : null}
                <span>{tool.label}</span>
              </div>
            );
          })}

          {typeof onClearChat === 'function' ? (
            <div
              className="plus-menu-item"
              role="button"
              tabIndex={0}
              onClick={() => onClearChat()}
              onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                  e.preventDefault();
                  onClearChat();
                }
              }}
            >
              🗑️ Clear Chat
            </div>
          ) : null}
        </div>
      </div>
    </div>
  );
}
